import { createPortal } from "react-dom";
import { StyledDiv, StyledSlider } from "./MainSlider.style";
import Container from "@mui/material/Container";
import { getMainSliderRequest } from "api/requests";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import useHttp from "hooks/use-http";
import { IMG_BASE_URL } from "constants";
import SkeletonCM from "components/shared/Skeleton";

function SampleNextArrowAmazing(props) {
  const { className, style, onClick } = props;
  return (
    <div className="Nextarrow" onClick={onClick}>
      <ArrowForwardIosIcon
        className={className}
        style={{ ...style, display: "block" }}
      />
    </div>
  );
}

function SamplePrevArrowAmazing(props) {
  const { className, style, onClick } = props;
  return (
    <div className="Prevarrow" onClick={onClick}>
      <ArrowForwardIosIcon
        className={className}
        style={{ ...style, display: "block" }}
      />
    </div>
  );
}

function MainSliderCM() {
  const [image, setData] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();

  const getData = useCallback(async () => {
    const res = await request({
      url: getMainSliderRequest,
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      image: items.image,
    }));

    setData({ data: transformedData });
  }, [request]);

  useEffect(() => {
    getData();
  }, [getData]);

  let settingsGallary = {
    // dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // rtl: true,
    nextArrow: <SamplePrevArrowAmazing />,
    prevArrow: <SampleNextArrowAmazing />,
  };

  return createPortal(
    <>
      <StyledDiv>
        <Container style={{ maxWidth: "100%", padding: "0" }}>
          {loading ? (
            <SkeletonCM Height={300} />
          ) : (
            <StyledSlider {...settingsGallary}>
              {image.data.map((items, index) => {
                return (
                  <div key={index}>
                    <img src={IMG_BASE_URL + items?.image} alt="banner" />
                  </div>
                );
              })}
            </StyledSlider>
          )}
        </Container>
      </StyledDiv>
    </>,
    document.getElementById("main_slider")
  );
}

export default MainSliderCM;
